import { Link } from 'react-router-dom';
import { videoList } from '@/mocks/videos';

const entries = [
  {
    type: 'movie',
    label: '电影',
    desc: '动作 · 科幻 · 爱情 · 悬疑',
    icon: 'ri-film-line',
  },
  {
    type: 'tv',
    label: '电视剧',
    desc: '古装 · 都市 · 悬疑 · 武侠',
    icon: 'ri-tv-2-line',
  },
  {
    type: 'variety',
    label: '综艺',
    desc: '真人秀 · 音乐 · 美食 · 户外',
    icon: 'ri-mic-line',
  },
];

export default function CategoryEntries() {
  return (
    <section className="w-full py-10">
      <div className="mb-6">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
          <a href="#category-entries" className="cursor-pointer">分类快捷入口</a>
        </h2>
        <p className="mt-1.5 text-sm text-foreground-500">快速进入你感兴趣的频道，发现更多精彩内容</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
        {entries.map((entry) => {
          const count = videoList.filter((item) => item.type === entry.type).length;
          return (
            <Link
              key={entry.type}
              to={`/category/${entry.type}`}
              className="group flex items-center gap-4 p-5 rounded-lg bg-background-100 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
            >
              <span className="w-14 h-14 flex items-center justify-center rounded-lg bg-primary-100 text-primary-700 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${entry.icon} text-2xl`}></i>
              </span>
              <span className="flex-1">
                <span className="flex items-center gap-2">
                  <span className="font-heading font-semibold text-base text-foreground-950">{entry.label}</span>
                  <span className="px-1.5 py-0.5 rounded-full bg-accent-100 text-accent-800 text-xs">{count} 部</span>
                </span>
                <span className="block mt-1 text-xs text-foreground-500">{entry.desc}</span>
              </span>
              <i className="ri-arrow-right-line text-foreground-400 group-hover:text-primary-600 group-hover:translate-x-1 transition-all"></i>
            </Link>
          );
        })}
      </div>
    </section>
  );
}